import { FinancialModelData } from './financialModel'
import { getAdRamp } from './adRamp'

/**
 * 90-day performance guarantee: total ad spend in the rep campaign's first
 * 3 months as modeled (leader search months excluded, any custom ramp
 * included) ÷ the top of the cost-per-hire range, rounded down.
 */
export function getGuaranteedHires(
  model: FinancialModelData,
  fallbackCphHigh: number,
): number {
  const [m1, m2, m3] = getAdRamp(model).months
  const cphHigh = model.inputs.cphHigh ?? fallbackCphHigh
  if (!cphHigh || cphHigh <= 0) return 0
  const spend = m1 + m2 + m3
  // Ads paused for all three months: nothing to guarantee.
  if (spend <= 0) return 0
  return Math.max(1, Math.floor(spend / cphHigh))
}
